// AEMAI 集合页分页记忆 v6：改写链接 href 恢复分页（不拦截默认导航）
(function() {
  var KEY = 'aemai_collection_page';
  // 集合页记录当前分页
  if (location.pathname.indexOf('/collections/all') >= 0 && /page=\d+/.test(location.search)) {
    var clean = location.pathname + location.search.replace(/[?&]ts=\d+/, '');
    try { sessionStorage.setItem(KEY, clean); } catch(e) {}
  }
  // 监听点击：改写指向 collections/all 的链接 href（提前到捕获阶段）
  document.addEventListener('click', function(e) {
    var node = e.target;
    var link = null;
    while (node && node !== document.body) {
      if (node.tagName === 'A') { link = node; break; }
      node = node.parentNode;
    }
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('/collections/all') < 0) return;
    if (/page=\d+/.test(href)) return;
    var outer = link.outerHTML || '';
    if (outer.indexOf('aemai-header-cta') >= 0 || outer.indexOf('aemai-drawer-cta') >= 0) return;
    var saved = null;
    try { saved = sessionStorage.getItem(KEY); } catch(err) {}
    if (!saved || /page=\d+/.test(location.search)) return;
    if (saved.indexOf('/collections/all') < 0) return;
    // 关键：改写 href 为记忆分页（保留默认导航行为，不 preventDefault）
    var cleanSaved = saved.replace(/[?&]ts=\d+/, '');
    link.setAttribute('href', cleanSaved);
  }, true);
})();
